import React from 'react';
import styled from 'styled-components';
import colors from '../../styles/colors';
import { Dismissible } from '../../utils/dismissible';
import { IconButton } from '../buttons';
import { QuestionOptions } from './';
import PillsSelect from '../inputs/pills-select';

export interface PillsTooltipProps {
  className?: string;
  left?: number;
  top?: number;
  options: QuestionOptions[];
  title?: string;
  selected?: string | string[];
  onClose?: () => void;
  onChange?: (results: any) => void;
}

const TRIANGLE_HEIGHT = 10;

class PillsTooltip extends React.Component<PillsTooltipProps, any> {
  render() {
    const {
      className,
      onClose,
      onChange,
      options,
      selected,
      title,
    } = this.props;

    return (
      <Dismissible
        onClickAway={onClose}
        className={`${className} pills-tool-tip`}
      >
        <IconButton
          className="close-button"
          icon="close"
          size="xs"
          baseColor="white"
          onClick={onClose}
        />
        <div className="pills-tool-tip-body">
          <div className="pills-tool-tip-title">{title}</div>
          <PillsSelect
            className="pill-button"
            options={options}
            onChange={onChange}
            selected={selected}
          />
        </div>
      </Dismissible>
    );
  }
}

const StyledPillsTooltip = styled(PillsTooltip)`
  position: absolute;
  top: ${({ top }) => top + TRIANGLE_HEIGHT}px;
  left: ${({ left }) => left}px;
  transform: translate(-50%, 18px);
  z-index: 1;
  width: auto;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 0 1rem 0 ${colors.grey100};
  background: ${colors.darkTransparent};

  :before {
    content: '';
    top: -${TRIANGLE_HEIGHT}px;
    left: 50%;
    width: 0;
    height: 0;
    position: absolute;
    transform: translateX(-${TRIANGLE_HEIGHT}px);
    border-left: ${TRIANGLE_HEIGHT}px solid transparent;
    border-right: ${TRIANGLE_HEIGHT}px solid transparent;
    border-bottom: ${TRIANGLE_HEIGHT}px solid ${colors.darkTransparent};
  }

  .close-button {
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    padding: 1.25em;

    :hover {
      background: none !important;
    }
  }

  .pills-tool-tip-body {
    padding: 1em;

    .pills-tool-tip-title {
      font-size: 1em;
      margin: 0 0.25em 1em;
      padding-right: 1.25em;
      text-transform: capitalize;
    }

    div,
    .pill-button {
      background: transparent;
      color: white;
      border: none;
    }

    .pill-button {
      border: 1px solid white;
      margin: 0.25em;
      border-radius: 4px;
      font-size: 0.9em;
      padding: 1em 1.5em;
      text-transform: capitalize;

      &.selected {
        background: ${colors.grey10};
      }
    }
  }
`;

export default StyledPillsTooltip;
